require('./bootstrap');
require('bootstrap/js/src/tooltip');
require('./components/job-inner');
require('./components/employer-details');
require('./components/filter');
require('./components/location-autocomplete');
require('./components/list-item');
require('./components/job-listing');
require('./components/job-save');
require('./components/job-seeker-profiles-listing');
require('./components/employer-logo');
require('./components/image-gallery-display');
require('./components/navbar');
require('./components/tooltip');
require('./components/search_filters');
require('jquery-ui/ui/widgets/autocomplete');
require('./pages/job_seeker_profile/profile');
require('./pages/account/password-is-not-set-modal');
require('./pages/pricing');
require('./pages/contact-us');
require('./jb/index');
require('bootstrap-select');
require('./utils/compute-new-class');
require('./components/forms/fields/select-picker-input');
require('./components/forms/fields/checkbox-multi-select');
require('./components/forms/fields/text-with-icon');
require('./components/forms/fields/password');
require('./components/forms/fields/image-gallery');
require('./components/mobile-menu');
require('./layout-utils');

$(() => {
  if ($('#unsubscribe-modal').length) {
    $('#unsubscribe-modal').modal('show');
  }

  $('.modal-delete-item').modal({
    show: false,
  });
});
